import AnswerText from './AnswerText'
import AnswerChoice from './AnswerChoice'
import AnswerOrder from './AnswerOrder'
import AnswerCategories from './AnswerCategories'
import AnswerBlanks from './AnswerBlanks'
import AnswerImage from './AnswerImage'
import AnswerMatch from './AnswerMatch'

// question_type → learner answer component.
// Every component gets: question, draft, onChange(draft), checked, order (shuffled ids), onSubmit
export const ANSWER_COMPONENTS = {
  type1: AnswerText,
  type2: AnswerChoice,
  type3: AnswerOrder,
  type4: AnswerCategories,
  type5: AnswerBlanks,
  type6: AnswerImage,
  type7: AnswerMatch,
}

// What the learner has to do, per type
export const TYPE_HINTS = {
  type1: 'qv_hint_type1',
  type2: 'qv_hint_type2',
  type3: 'qv_hint_type3',
  type4: 'qv_hint_type4',
  type5: 'qv_hint_type5',
  type6: 'qv_hint_type6',
  type7: 'qv_hint_type7',
}
